const functionalMap = {
  gridTitle: "מפה פונקציונלית של GAM",
  lockedNotice: "מבנה נעול: 3 רמות × 5 פונקציות. לא ניתן להוסיף/להסיר תאים.",
  levelStrategy: "אסטרטגיה",
  levelManagement: "ניהול",
  levelOperations: "ביצוע",
  funcSales: "מכירות",
  funcDelivery: "ביצוע פרויקטים",
  funcFinance: "כספים",
  funcHr: "משאבי אנוש",
  funcTechnology: "טכנולוגיה",
  statusActive: "פעיל",
  statusPartial: "חלקי",
  statusPlanned: "מתוכנן",
  owner: "אחראי",
  tools: "כלים",
  description: "תיאור",
  clickToEdit: "לחץ לעריכה",
  saving: "שומר...",
  saved: "נשמר",
  legend: "מקרא",
  noOwner: "לא הוגדר",
  realtimeConnected: "מחובר",
  realtimeConnecting: "מתחבר...",
  realtimeDisconnected: "מנותק",
  items: "פריטים",
  addItem: "הוסף פריט",
  itemPlaceholder: "פריט חדש...",
  noItems: "אין פריטים עדיין",
  notes: "הערות",
  kpis: "מדדים",
  addKpi: "הוסף מדד",
  noKpis: "אין מדדים",
  links: "קישורים",
  addLink: "הוסף קישור",
  noLinks: "אין קישורים",
  progress: "התקדמות",
  details: "פרטים",
  lastUpdated: "עודכן",
  stale: "לא עודכן",
  cells: "תאים",
  labelPlaceholder: "שם",
  valuePlaceholder: "ערך",
  targetPlaceholder: "יעד",
  daysAgo: "ימים",
  filterAll: "הכל",
} as const;
export default functionalMap;
